<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="7">
      <v-card class="pa-5" outlined>
        <v-card-text>
          <h1 class="text-h4 black--text"
            >This shop is undergoing temporary maintenance. Please check back in
            a bit, thanks.</h1
          >
        </v-card-text>
      </v-card>
      <div class="px-8 py-3">
        <h2 class="text-h5 font-weight-bold mt-4">Have a question?</h2>
        <p class="text-h5">
          Please send an email to
          <a
            class="email-link d-inline-block"
            :href="`mailto:${getShopDetail('Contact Email')}`"
            >{{ getShopDetail('Contact Email') }}</a
          >
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { GuestRoutes } from '@/constants/RouteNames'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'MaintenanceModeView',
  data: () => {
    return {
      fetchInterval: null,
    }
  },
  computed: {
    ...mapGetters('shop', [
      'getShopDetail',
      'getShopTitle',
      'getIsMaintenanceModeOn',
    ]),
  },
  created() {
    this.fetchInterval = setInterval(() => this.fetchShop(true), 30000)
  },
  beforeDestroy() {
    if (!this.fetchInterval) return
    clearInterval(this.fetchInterval)
  },
  methods: {
    ...mapActions('app', ['loadNewVersion']),
    ...mapActions('shop', ['fetchShop']),
  },
  watch: {
    getIsMaintenanceModeOn: {
      handler(val) {
        if (!val) {
          this.$router.push({ name: GuestRoutes.HOME })
        }
      },
      immediate: true,
    },
  },
}
</script>
